module.exports = __webpack_public_path__ + "52cec365b9ce886228c65914f940adfc.svg";